var map = {
	"./IUsInStock.js": "2e50",
	"./IUsReceived.js": "cdfc",
	"./IUsShipped.js": "c184",
	"./auth.js": "c7d4",
	"./countryDashboard.js": "c4c1",
	"./dashboard.js": "76b5",
	"./general.js": "d886",
	"./generalData.js": "d20b",
	"./globalDimensionFilter.js": "5f4a",
	"./globalFilter.js": "85bf",
	"./graph.js": "b77c",
	"./home.js": "e542",
	"./internalStatus.js": "ec2f",
	"./patientTreatedByAgeGroup.js": "2be8",
	"./patientsTreated.js": "b996",
	"./shippedVsReported.js": "1dc9",
	"./totalDonationMG.js": "a306",
	"./totalDonationMIU.js": "ffd7",
	"./trendOfDonations.js": "da35",
	"./user.js": "0f9a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c17";